import logo from '@images/logo.png';
import google from '@icons/google.svg';
import login_image from '@images/Login-image.jpg';
import google_play from '@images/google_play.jpg';
import app_store from '@images/app_store.jpg';

export const staticImages = {
    logo,
    google,
    login_image,
    google_play,
    app_store,
};
